<template>
  <v-form ref="form" v-model="valid">
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="customer.name"
          :rules="rules.required"
          :label="$t('customers.list.name')"
          required
          ref="firstfield"
          :tabIndex="10201"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="9">
        <v-text-field v-model="customer.playerUrl" :rules="rules.required" :label="$t('customers.list.playerUrl')" required :tabIndex="10202"></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-textarea v-model="customer.description" :label="$t('customers.list.description')" required :tabIndex="10203"></v-textarea>
      </v-col>

      <v-col cols="12">
        <small>{{ $t("common.form.requiredText") }}</small>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import axios from "axios";

import { formatMixin, listMixin, formMixin } from "@/helpers/mixins";

export default {
  mixins: [formatMixin, listMixin, formMixin],

  data() {
    return {
      data: {},
      valid: false,
      customer: {
        name: "",
        playerUrl: "",
      },
    };
  },

  props: {
    onSuccess: {
      type: Function,
    },
  },

  components: {},

  computed: {},

  created() {},

  methods: {
    init: function(id) {
      this.reset();

      if (id) {
        axios
          .get(`/api/customers/${id}`)
          .then((msg) => {
            this.customer = msg.data;
          })
          .catch((e) => {
            console.log(e);
            this.$store.dispatch("showSnackMessage", { message: e });
          });
      }
    },

    reset: function() {
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }
    },

    save: function() {
      if (this.$refs.form.validate()) {
        axios
          .post(`/api/customers/${this.customer.id || ""}`, this.customer)
          .then((msg) => {
            this.onSuccess(msg.data);
          })
          .catch((e) => {
            console.log(e);
            this.$store.dispatch("showSnackMessage", { message: e });
          });
      }
    },
  },
};
</script>
